export const SELF_REGISTRATION_RESET_LEFT_ACTIVATION_CODES_DATE_TYPES = {
  SPECIFIC_DATE: "Specific date",
  END_OF_CURRENT_YEAR: "End of  current year",
  NUMBER_OF_DAYS: "Number of days",
  NO_RESET: "No reset",
};
